import type { WidgetProps } from '@rjsf/utils';
import { enumOptionsIsSelected } from '@rjsf/utils';

/**
 * Pill-style radio widget matching the Surface form design.
 * Renders enum options as horizontal rounded-rectangle buttons in a grid.
 */
export const PillRadioWidget = ({ options, value, disabled, readonly, onChange }: WidgetProps) => {
  const { enumOptions, enumDisabled } = options;

  if (!Array.isArray(enumOptions) || enumOptions.length === 0) return null;

  return (
    <div className="grid gap-3" style={{ gridTemplateColumns: `repeat(${Math.min(enumOptions.length, 4)}, 1fr)` }}>
      {enumOptions.map((option, index) => {
        const itemDisabled = Array.isArray(enumDisabled) && enumDisabled.indexOf(option.value) !== -1;
        const isSelected = enumOptionsIsSelected(option.value, value);

        return (
          <button
            key={index}
            type="button"
            disabled={disabled || readonly || itemDisabled}
            onClick={() => onChange(option.value)}
            className={`py-3 px-4 rounded-xl border text-lg font-medium transition-colors ${
              isSelected
                ? 'border-primary bg-primary/5 text-foreground'
                : 'border-border bg-muted text-foreground hover:border-foreground/20'
            } disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};
